import LArtwork from "@components/LArtwork";
import LPressable from "@components/LPressable";
import { moderateScale } from "@utils/scale";
import { memo } from "react";
import Decagon from "@components/Activity/Decagon";

interface StaticArtworkProps {
  url?: string;
  blurhash?: string | null;
  onPress: () => void;
}

const StaticArtwork = ({ url, blurhash, onPress }: StaticArtworkProps) => {
  return (
    <LPressable sentryEventName="open_music_player" onPress={onPress}>
      <Decagon size={moderateScale(45)} showBackground={false}>
        <LArtwork
          url={url}
          imageSize="small"
          size={moderateScale(45)}
          blurhash={blurhash}
        />
      </Decagon>
    </LPressable>
  );
};

export default memo<StaticArtworkProps>(StaticArtwork);
